import apiClient from "./api";
const ESTUDIOSINT_API_BASE_URL = "/estudiosInt";
class EstudiosIntService {

  async getEstudiosPorEstudio(estudioId) {
    try {
      const response = await apiClient.get(`${ESTUDIOSINT_API_BASE_URL}/estudio/${estudioId}`,);
      return response.data.estudios;
    } catch (error) {
      console.error(error);
    }
  }
}
export default new EstudiosIntService();